
  import Vue from "vue";
  import { UserInfo } from "@/types/User";
  import EditableCoOwnersList from "@/components/Portal/EditableCoOwnersList.vue";
  import FooterText from "@/components/common/FooterText.vue";
  import ASCAArtIncLink from "@/components/common/ASCAArtIncLink.vue";
  import BylawsLink from "@/components/common/BylawsLink.vue";
  import { OwnershipType } from "@/components/common/CoownersList.vue";

  export default Vue.extend({
    name: "OwnerInformation",
    components: { FooterText, EditableCoOwnersList, ASCAArtIncLink, BylawsLink },
    props: {
      changePage: Function,
      registerMember: Boolean,
      renewMember: Boolean,
      signature: String,
      dogOwners: Array,
      updateSelectedCoownersFn: Function,
      searchCoownersFn: Function,
      updateSignatureFn: Function,
    },
    data: function () {
      return {
        agreementDate: new Date(),
        coOwnerDialog: false,
        selectedCoowners: this.dogOwners as any[],
        signatureText: this.$props.signature,
      }
    },
    computed: {
      userInfo(): UserInfo {
        return this.$store.state.userInfo;
      },
      dogOwnershipType: function() {
        return OwnershipType.Dog;
      },
    },
    methods: {
      toggleCoOwnerModal: function () {
        this.$data.coOwnerDialog = !this.$data.coOwnerDialog;
      },
      isValid() {
        return !this.registerMember && !this.renewMember && !!this.signatureText && this.dogOwners.length > 0;// && this.dogOwners.some(own => own.isPrimary);
      },
      addComma(targetValue: string | null, afterValue: string | null) {
        if (!targetValue) return '';
        else if (!!afterValue) return `${targetValue},`;
        else return targetValue;
      },
      updateSelectedCoowners: function (val: any) {
        this.selectedCoowners = val.newPeople;
      },
    }
  });
  